import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('formErrors');

    return {
        PLEASE_CORRECT_THE_FOLLOWING: t('pleaseCorrectTheFollowing')
    };
};

export default useTranslation;
